module.exports = __webpack_public_path__ + "img/MultiLine.4182d6ce.svg";